export default __webpack_public_path__ + "static/media/sounds/TRO_Read_Answer_Questions.mp3";